<smrts-dialog title="Busca em massa" [hasFootnote]="true">

  <div class="busca-em-massa-content">

    @if (processando) {
      <p>Buscando correspondências em massa{{ total > 0 ? ' para ' + total + ' lançamento(s)' : '' }}...</p>
      <mat-progress-bar mode="determinate" [value]="percentualConcluido"></mat-progress-bar>
      <div class="processando-footer">
        <p class="progresso-texto">{{ processados }} de {{ total }} processado(s)</p>
        @if (segundosRestantes > 0) {
          <div class="contagem-regressiva inline-element" matTooltip="Tempo restante até o timeout de busca do lançamento atual">
            <mat-icon>schedule</mat-icon>
            {{ segundosRestantes }}s
          </div>
        }
      </div>
    }

    @if (!processando && resumo; as r) {
      @if (r.cancelado) {
        <div class="aviso-cancelado inline-element">
          <mat-icon fontSet="material-icons-outlined">info</mat-icon>
          Busca em massa interrompida.
        </div>
      }
      <div class="resumo-sucesso inline-element">
        <mat-icon class="resumo-sucesso-icon">check_circle</mat-icon>
        <span>
          <strong>{{ r.conciliadosAutomaticamente }}</strong> de {{ r.totalProcessados }} lançamento(s) conciliado(s) automaticamente
        </span>
        @if (r.conciliadosAutomaticamente > 0) {
          <button mat-icon-button class="visibility-btn" matTooltip="Ver lançamentos conciliados"
            (click)="abrirListagem('Conciliados automaticamente', r.itensConciliados, true)">
            <mat-icon>visibility</mat-icon>
          </button>
        }
      </div>
      @if (existeItemParaRevisao(r)) {
        <div class="resumo-revisao">
          <p class="resumo-revisao-titulo">Lançamentos não conciliados:</p>
          @if (r.semCorrespondencia > 0) {
            <div class="resumo-item inline-element">
              <mat-icon>search_off</mat-icon>
              <span>{{ r.semCorrespondencia }} sem correspondência encontrada</span>
              <button mat-icon-button class="visibility-btn" matTooltip="Ver lançamentos" (click)="abrirListagem('Sem correspondência encontrada', r.itensSemCorrespondencia)">
                <mat-icon>visibility</mat-icon>
              </button>
            </div>
          }
          @if (r.comMultiplasCorrespondencias > 0) {
            <div class="resumo-item inline-element">
              <mat-icon>call_split</mat-icon>
              <span>{{ r.comMultiplasCorrespondencias }} com múltiplas correspondências encontradas</span>
              <button mat-icon-button class="visibility-btn" matTooltip="Ver lançamentos" (click)="abrirListagem('Com múltiplas correspondências', r.itensComMultiplasCorrespondencias)">
                <mat-icon>visibility</mat-icon>
              </button>
            </div>
          }
          @if (r.comConflitoEntreLancamentos > 0) {
            <div class="resumo-item inline-element">
              <mat-icon>report_problem</mat-icon>
              <span>{{ r.comConflitoEntreLancamentos }} com correspondências encontradas em mais de um lançamento</span>
              <button mat-icon-button class="visibility-btn" matTooltip="Ver lançamentos" (click)="abrirListagem('Correspondência já usada por outro lançamento', r.itensComConflitoEntreLancamentos)">
                <mat-icon>visibility</mat-icon>
              </button>
            </div>
          }
          @if (r.comTimeout > 0) {
            <div class="resumo-item inline-element">
              <mat-icon>schedule</mat-icon>
              <span>{{ r.comTimeout }} com tempo limite de busca excedido</span>
              <button mat-icon-button class="visibility-btn" matTooltip="Ver lançamentos" (click)="abrirListagem('Com tempo limite de busca excedido', r.itensComTimeout)">
                <mat-icon>visibility</mat-icon>
              </button>
            </div>
          }
        </div>
      }
    }

  </div>

  <div footnote class="inline-element footnote">
    @if (processando) {
      <button class="accent-text-button" mat-button [disabled]="parando" [mat-dialog-close]="false" (click)="cancelarClick()">
        Cancelar
      </button>
    }
    @if (processando) {
      <button class="accent-text-button" mat-button [disabled]="parando" (click)="interromperClick()">
        {{ acaoParada === 'interromper' ? 'Interrompendo...' : 'Interromper' }}
      </button>
    }
    @if (!processando) {
      <button class="white-text-button" mat-flat-button [mat-dialog-close]="true">
        Fechar
      </button>
    }
  </div>
</smrts-dialog>
